import { getParentOfType, Instance, types } from 'mobx-state-tree';

import { ProductKit } from './ProductKit';
import { EnrollmentKitSelectionStore } from './EnrollmentKitStore';

const TabTypes = ['Popular', 'Premium', 'Specialty', 'Basic', 'Other'] as const;

export type TabType = typeof TabTypes[number];

export type TabLabel = 'PopularPremium' | 'OtherPremium' | 'SpecialtyKits' | 'BasicKits' | 'OtherKits';

export const StarterKitTab = types
  .model({
    id: types.identifierNumber,
    tabType: types.enumeration<TabType>('TabType', TabTypes as any),
    displayStyle: types.enumeration('DisplayStyle', ['Classic', 'Dynamic', 'Grid', 'Basic']),
    productKits: types.array(types.late(() => ProductKit))
  })
  .views(self => ({
    get labelKey(): TabLabel {
      switch (self.tabType) {
        case 'Popular':
          return 'PopularPremium';
        case 'Premium':
          return 'OtherPremium';
        case 'Specialty':
          return 'SpecialtyKits';
        case 'Basic':
          return 'BasicKits';
        case 'Other':
          return 'OtherKits';
        default:
          throw new Error(`TabType ${self.tabType} not supported`);
      }
    },
    get kitStore(): EnrollmentKitSelectionStore {
      return getParentOfType(self, EnrollmentKitSelectionStore);
    },
    get dynamicKitPrice(): number {
      if (this.kitStore.selectedKitTab === self && this.kitStore.selectedKit) {
        return this.kitStore.selectedKit.price;
      }
      return self.productKits[0].price;
    }
  }));

export type StarterKitTab = Instance<typeof StarterKitTab>;
